import { Image as ChakraImage, ImageProps as ChakraImageProps } from '@chakra-ui/react';

export type ImageProps = ChakraImageProps;

const Image = (props: ImageProps) => <ChakraImage {...props} />;

export { Image };
